import React from "react";
import BarekamText from "../../../../../../components/text";
import {Message, MessageSections} from "../../../../../../components/message/message";
import {BarekamSelect} from "../../../../../../components/select/select";
import {ProductCategoryModel} from "../../../../../../../redux/reducers/static-data.reducers";
import {MenuItem} from "@mui/material";
import {useAppSelector} from "../../../../../../../redux/store";

const CategoryFilter = (props: CategoryFilterProps) => {
    const {selectedFilterId, productCategories, onFilterChange} = props;
    const {languageId} = useAppSelector(state => state.messagesReducer);

    return (
        <>
            <BarekamSelect
                variant={'outlined'}
                label={<Message messageKey={'category'} sectionId={MessageSections.ORDERS}/>}
                value={selectedFilterId || 'all'}
                type={"filter"}
                fullWidth
                required>
                <MenuItem onClick={() => onFilterChange(undefined)}
                                value={'all'}
                                key={'all'}>
                    <BarekamText variant={"m"}>
                        <Message messageKey={"all"} sectionId={MessageSections.ORDERS}/>
                    </BarekamText>
                </MenuItem>
                {

                    productCategories.map(category =>
                        <MenuItem onClick={() => onFilterChange(category)}
                                        value={category.productCategoryId}
                                        key={category.productCategoryId}>
                            <BarekamText variant={"m"}>
                                {category.name[languageId]}
                            </BarekamText>
                        </MenuItem>
                    )
                }
            </BarekamSelect>
        </>
    );
};

export default CategoryFilter;


interface CategoryFilterProps {
    selectedFilterId: number | undefined;
    productCategories: ProductCategoryModel[];
    onFilterChange: (filter: ProductCategoryModel | undefined) => void
}